<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title appLifecycleTracker trackerName="create-admin-event-dialog">
    {{'CREATE_ADMIN_EVENT_TITLE' | translate}}
</h2>
<div mat-dialog-content class="dialog-wrapper">
    <div>
        <mat-form-field appearance="outline">
            <mat-label>{{'EVI_SEVERITY' | translate}}</mat-label>
            <mat-select [(ngModel)]="severity">
                <mat-option *ngFor="let severity of severities" [value]="severity">{{severity.displayValue}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div>
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{'EVI_DESC' | translate}}</mat-label>
            <input matInput type="text" maxlength="255" [(ngModel)]="description">
            <button *ngIf="description.length" matSuffix mat-icon-button aria-label="Clear" (click)="description=''">
                <span class="mdi mdi-close" aria-hidden="true"></span>
            </button>
            <mat-hint align="end">{{description.length}} / 255</mat-hint>
        </mat-form-field>
    </div>

    <div>
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{'EVI_DETAIL' | translate}}</mat-label>
        <textarea matInput [(ngModel)]="detail"></textarea>
      </mat-form-field>
    </div>
</div>

<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClose()" type="button">{{'CANCEL' | translate}}</button>
    <button mat-raised-button (click)="onSubmit()" type="button" color="primary">{{'SAVE' | translate}}</button>
</div>
